import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { BusinessFinanceSummary } from '@portal-workspace/grow-shared-library';
import { FormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { booleanToYesNo, DirectorValue, displaybleDate, MemberValue, notNullUndefined, PartnerValue, SoleTraderValue, SummaryEntityValue, TrusteeValue } from '@portal-workspace/grow-shared-library';
import { categoriesApplicants, summaryEntityParties } from '@portal-workspace/grow-ui-library';
import { CellComponent } from './cell.component';
import { EntitiesSummaryComponent } from './entities-summary.component';
import { DirectorsSummaryComponent } from './directors-summary.component';
import { GuarantorsSummaryComponent } from './guarantors-summary.component';
import { MembersSummaryComponent } from './members-summary.component';
import { PartnersSummaryComponent } from './partners-summary.component';
import { PrimaryContactSummaryComponent } from './primary-contact-summary.component';
import { ContactsSummaryComponent } from './contacts-summary.component';
import { SoletradersSummaryComponent } from './soletraders-summary.component';
import { TrusteesSummaryComponent } from './trustees-summary.component';
import { LoanPurposeSummaryComponent } from '../loan-purpose-summary/loan-purpose-summary.component';

@Component({
    selector: 'business-finance-summary',
    templateUrl: './business-finance-summary.component.html',
    styleUrls: ['./business-finance-summary.component.scss'],
    standalone: true,
    imports: [LoanPurposeSummaryComponent, MatFormFieldModule, MatInputModule, FormsModule, CellComponent, MatDividerModule, DirectorsSummaryComponent, TrusteesSummaryComponent, PartnersSummaryComponent, MembersSummaryComponent, SoletradersSummaryComponent, GuarantorsSummaryComponent, PrimaryContactSummaryComponent, ContactsSummaryComponent, EntitiesSummaryComponent]
})
export class BusinessFinanceSummaryComponent implements OnInit,OnChanges {

  booleanToYesNo = booleanToYesNo;
  displayableDate = displaybleDate;
  notNullUndefined = notNullUndefined;

  _trustee?: Exclude<TrusteeValue, null>;
  _members?: Exclude<MemberValue, null>;
  _soleTraders?: (Exclude<SoleTraderValue, null>)[];
  _directors?: Exclude<DirectorValue, null>;
  _partners?: Exclude<PartnerValue, null>;
  _entities?: SummaryEntityValue[];

  @Input({required: true}) summary!: BusinessFinanceSummary;

  ngOnInit(): void {
  }
  ngOnChanges(){
    if (this.summary && this.summary.applicants) {
      const r = categoriesApplicants(this.summary.applicants);
      this._directors = r.directors.length ? r.directors : undefined;
      this._trustee = r.trustees.length ? r.trustees : undefined;
      this._members = r.members.length ? r.members : undefined;
      this._partners = r.partners.length ? r.partners : undefined;
      this._soleTraders = r.soletraders.length ? r.soletraders : undefined;
    }
    this._entities = summaryEntityParties(this.summary?.applicants, this.summary?.guarantors);
  }

}
